import { useState } from 'react';
import { INavigation } from '../../types/navigation'
import { useAuth0 } from '@auth0/auth0-react';

const MobileNavigation = ({
  navLinksData,
  customerSupportData,
  isGroupIdsValid,
}: {
  navLinksData: INavigation[];
  customerSupportData: INavigation[];
  isGroupIdsValid: boolean;
}) => {
  const [mobileServiceIsOpen, toggleMobileServiceOpen] = useState(false);
  const { logout } = useAuth0();

  return (
    <>
      <ul>
        {navLinksData.map(item =>
          item.subNav === null ? (
            <li key={item.name}>
              {/* If it's an Auth0 link, it should be an <a> tag rather than <Link> --> https://community.auth0.com/t/nextjs-cors-no-access-control-allow-origin-header-is-present-on-the-requested-resource/125578/4*/}
              {item.userMenu ? (
                item.logout ? (
                  isGroupIdsValid && (
                    <button
                      className="flex w-full items-center rounded-md px-3 py-2 text-base font-sm text-black hover:bg-gray-700 hover:text-white"
                      onClick={() => logout({logoutParams: {returnTo: window.location.origin}})}
                    >
                      <div className="ml-7 mr-3">{item.image}</div>
                      {item.name}
                    </button>
                  )
                ) : (
                  <a
                    href={item.href}
                    className="flex items-center rounded-md px-3 py-2 text-base font-sm text-black hover:bg-gray-700 hover:text-white"
                  >
                    <div className="ml-7 mr-3">{item.image}</div>
                    {item.name}
                  </a>
                )
              ) : (
                isGroupIdsValid && (
                  <a
                    href={item.href}
                    className="flex items-center rounded-md px-3 py-2 text-base font-sm text-black hover:bg-gray-700 hover:text-white"
                  >
                    <div className="ml-7 mr-3">{item.image}</div>
                    {item.name}
                  </a>
                )
              )}
            </li>
          ) : (
            isGroupIdsValid && (
              <li key={item.name}>
                <button
                  onClick={() => toggleMobileServiceOpen(!mobileServiceIsOpen)}
                  className="flex items-center w-full rounded-md px-3 py-2 text-base font-sm text-black hover:bg-gray-700 hover:text-white"
                  aria-controls="mobile-services-menu"
                  aria-expanded="false"
                >
                  <div className="ml-7 mr-3">{item.image}</div>
                  {item.name}
                  {mobileServiceIsOpen ? (
                    <svg
                      className="w-2.5 h-2.5 ml-auto mr-4"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 10 6"
                    >
                      <path
                        stroke="#B0557E"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="m1 1 4 4 4-4"
                      ></path>
                    </svg>
                  ) : (
                    <svg
                      className="w-2.5 h-2.5 ml-auto mr-4 rotate-180"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 10 6"
                    >
                      <path
                        stroke="#B0557E"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="m1 1 4 4 4-4"
                      ></path>
                    </svg>
                  )}
                </button>
                {mobileServiceIsOpen ? (
                  <ul>
                    {item.subNav.map(subNavElements => (
                      <li key={subNavElements.name}>
                        <a
                          href={subNavElements.href}
                          className="flex items-center rounded-md px-10 py-2 text-base font-sm text-black hover:bg-gray-700 hover:text-white"
                        >
                          <div className="ml-7 mr-3">{subNavElements.image}</div>
                          {subNavElements.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                ) : null}
              </li>
            )
          )
        )}
      </ul>
      {isGroupIdsValid && (
        <>
          <div className="ml-7 pt-2 font-bold">Get Support</div>
          <ul>
            {customerSupportData.map(item => (
              <li key={item.name}>
                <a
                  href={item.href}
                  className="flex items-center rounded-md px-3 py-2 text-base font-sm text-inglelewer-pink hover:bg-gray-700"
                >
                  <div className="mt-1 ml-7 mr-3">{item.image}</div>
                  {item.name}
                </a>
              </li>
            ))}
          </ul>
        </>
      )}
    </>
  );
};

export default MobileNavigation;
